<template>
  <div class="p-right-25-important mobile-p-top-30">
    <!-- Display call logs grouped by date -->
    <div v-if="Object.keys(communicationData).length > 0">
      <div v-for="(group, date) in communicationData" :key="date">
        <div class="row mobile-p-bottom-0">
            <div class="clearfix"></div>
          <div class="col-md-offset-3 col-md-6 created-date">
            {{ date }}
          </div>
        </div>
        <div v-for="(communicationRow, index) in group">
          <call-log-row v-if="communicationRow.component_type=='callLog'"  :log="communicationRow" :key="index"></call-log-row>
          <discussion-tab-row v-else-if="communicationRow.component_type=='discussion' && credentials.canDiscussion" :discussion="communicationRow"
                              :itemType="itemType" :itemId="itemId"
                              :key="index" :logged-user-id="credentials.loggedUserId" @on-delete="deleteDiscussion(communicationRow,date)"></discussion-tab-row>

          <issue-discussion-tab-row v-else-if="communicationRow.component_type=='issueDiscussion' && credentials.canDiscussion" :discussion="communicationRow"
                                     :itemType="itemType" :itemId="itemId"
                                     :key="index" :logged-user-id="credentials.loggedUserId" @on-delete="deleteDiscussion(communicationRow,date)"
                                      tabName="all"></issue-discussion-tab-row>

          <email-log-row v-else-if="communicationRow.component_type=='email'" :log="communicationRow" :key="index"></email-log-row>
          <sms-log-row v-else-if="communicationRow.component_type=='sms'" :log="communicationRow" :twilio-account-number="twilioAccountNumber" :key="index"></sms-log-row>

        </div>

      </div>
    </div>
  </div>

</template>

<script>
import CallLogRow from "./CallLogRow.vue";
import DiscussionTabRow from "./DiscussionTabRow.vue";
import EmailLogRow from "./EmailLogRow.vue";
import {EventBus} from "@/events/event-bus";
import IssueDiscussionTabRow from "./IssueDiscussionTabRow.vue";
import SmsLogRow from "./SmsLogRow.vue";
import ViewIssuePopup from "../Issues/ViewIssuePopup.vue";

export default {
    name: "AllCommunicationTabs",
  components: {ViewIssuePopup, SmsLogRow, IssueDiscussionTabRow, EmailLogRow, DiscussionTabRow, CallLogRow},
    props:{
      communicationData:{
          type:Object,
          required:true
      },
      credentials: {
        type: Object,
        default: () => ({}) // Default value is an empty object
      },
      itemType: {
        type: String
      },
      itemId: {
        type: Number
      }
    },
  data(){
      return{
        twilioAccountNumber: null
      }
  },
  methods: {
    deleteDiscussion(discussion,date){
      EventBus.$emit("onDeleteDiscusionFromAllTab",discussion,date)
    },
  },
  mounted(){
    EventBus.$on('setTwilioAccountNumber', (twilioAccountNumber) => {
      this.twilioAccountNumber = twilioAccountNumber
    })
  }
}
</script>

<style scoped>
.created-date{
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: rgb(98, 112, 124);
}
.p-right-25-important{
 padding-right: 25px !important;
}
@media (max-width: 991px) {
  .mobile-p-top-30 {
    padding-top: 30px !important;
  }
  .mobile-p-bottom-0{
    padding-bottom: 0px !important;
  }
}
</style>